<template>
  <div class="TableSkeleton" :class="[`TableSkeleton--${type}`]">
    <div class="TableSkeleton__bar shimmer"></div>
    <div class="TableSkeleton__bar shimmer"></div>
  </div>
</template>

<script>
export default {
  name: 'TableSkeleton',
  props: {
    type: {
      type: String,
      validator: function (value) {
        return ['default', 'sub'].indexOf(value) !== -1;
      },
      default: 'default',
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_pageForward.scss' as *;

.TableSkeleton {
  display: flex;

  &--default {
    padding: $service-unit * 2 $service-unit * 4 0;
  }

  &--sub {
    align-items: center;
    height: $service-unit * 10;
  }

  &__bar {
    height: $service-unit * 4;
    background-color: $color-gray-20;

    &:first-child {
      width: 100% * calc(160 / 1072);
    }

    &:nth-child(2) {
      width: 100% * calc(888 / 1072);
      margin-left: $service-unit * 6;
    }
  }

  &--sub &__bar {
    height: $service-unit * 4;

    &:first-child {
      width: $service-unit * 45;
    }

    &:nth-child(2) {
      width: 100% * calc(450 / 1104);
      margin-left: $service-unit * 6;
    }
  }
}
</style>
